import React from 'react';
import { Typography } from '@mui/material';
import { ModalType } from 'entities/modal/model';
import { ECOSYSTEM_LINKS, Icons, ModalSidebar } from 'shared';

export interface CommerceModalPayload {
  data?: null;
  type: ModalType.Commerce;
  isOpen?: boolean;
}

export const CommerceModal = React.forwardRef<
  HTMLElement,
  Pick<CommerceModalPayload, 'data' | 'isOpen'> & { onClose: VoidFunction }
>(({ onClose, isOpen }, ref) => {
  return (
    <ModalSidebar
      isOpen={isOpen}
      ref={ref}
      onClose={onClose}
      title="e-Commerce Trading Portal"
      subtitle="Online Shopping Without Middlemen"
      link={{
        title: 'Start Trading',
        link: {
          text: ECOSYSTEM_LINKS.useCases,
          href: ECOSYSTEM_LINKS.useCases,
        },
      }}
      icon={<Icons.CommerceDark />}
    >
      <Typography variant="inherit" component="p" color="inherit" fontFamily="inherit">
        The e-Commerce Portal is an online marketplace where businesses sell directly to customers.
      </Typography>
      <br />
      <Typography variant="inherit" component="p" color="inherit" fontFamily="inherit">
        Instead of paying big fees to traditional platforms, sellers and buyers interact through smart contracts on the
        blockchain.
      </Typography>
      <br />
      <Typography variant="inherit" component="p" color="inherit" fontFamily="inherit">
        This makes shopping cheaper, more transparent, and more secure, with payments settled in $CRAT.
      </Typography>
    </ModalSidebar>
  );
});
